module.exports = __webpack_public_path__ + "img/diretor_comite.d1cf00c5.png";